"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var yup_1 = require("yup");
exports.dropFormSchema = yup_1.object().shape({
    from: yup_1.string()
        .label('From')
        .oneOf(['xyoCollected', 'bossBalance'])
        .default('bossBalance'),
    maxAmount: yup_1.number()
        .label('Max Amount')
        .default(100),
    maxQuantity: yup_1.number()
        .label('Max Quantity')
        .default(10),
    maxAvailable: yup_1.number()
        .label('Max Available')
        .default(0),
    amount: yup_1.number()
        .default(10)
        .label('Amount')
        .required()
        .positive()
        .integer()
        .max(yup_1.ref('maxAmount')),
    quantity: yup_1.number()
        .default(1)
        .label('Quantity')
        .required()
        .positive()
        .integer()
        .max(yup_1.ref('maxQuantity')),
    title: yup_1.string()
        .default('')
        .label('Title')
        .required(),
    message: yup_1.string()
        .default('')
        .label('Message')
        .required(),
    link: yup_1.string()
        .default('')
        .label('Info Url')
        .required(),
    base64Image: yup_1.string()
        .label('Image Url')
        .required(),
    email: yup_1.string()
        .default('')
        .label('Email')
        .email()
        .when('restrictToEmail', {
        is: true,
        then: yup_1.string().required('Must enter email address'),
    }),
    quadkey: yup_1.string()
        .default('')
        .label('Quadkey')
        .when('restrictToQuadkey', {
        is: true,
        then: yup_1.string().required('Must select a quadkey'),
    }),
    restrictToEmail: yup_1.boolean()
        .label('Restrict To Email')
        .default(false),
    restrictToQuadkey: yup_1.boolean()
        .label('Restrict To Quadkey')
        .default(false),
});
//# sourceMappingURL=schema.js.map